import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <header
      aria-label="Jeff Dumè — Founder of BuildFit AI and Mainframe Solutions"
      className="relative min-h-screen flex flex-col justify-center overflow-hidden bg-charcoal"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-charcoal via-[#1e1e1e] to-[#0f0f0f]"></div>
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-gold/5 via-transparent to-transparent"></div>
      <div className="absolute bottom-0 left-0 w-2/3 h-1/2 bg-gradient-to-tr from-gold/5 via-transparent to-transparent"></div>

      <div className="relative z-10 w-full px-4 sm:px-6 md:px-10 lg:px-16 pt-20 sm:pt-24 pb-16">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row gap-8 sm:gap-10 lg:gap-16 items-start">

          {/* Mobile/Tablet image */}
          <div className="flex lg:hidden w-full justify-center">
            <div className="relative w-[160px] sm:w-[200px] md:w-[240px]">
              <div className="w-full aspect-[3/4] rounded-xl overflow-hidden border border-white/10 bg-dark-card">
                <img
                  src="/images/Jeff_D-28.jpg"
                  alt="Jeff Dumè, Founder of BuildFit AI and Mainframe Solutions, workforce intelligence advocate"
                  loading="eager"
                  fetchPriority="high"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-2 -right-2 w-full h-full rounded-xl border border-gold/20 -z-10"></div>
            </div>
          </div>

          {/* Text Column */}
          <div className="lg:w-[58%] w-full">
            <div
              className={`transition-all duration-700 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              <p className="text-gold text-xs md:text-sm font-semibold tracking-[0.25em] uppercase mb-4 sm:mb-6">
                Founder of BuildFit AI &amp; Mainframe Solutions
              </p>
            </div>

            <h1
              className={`transition-all duration-700 delay-100 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              <span className="block text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-[4.5rem] font-extrabold leading-[1.05] font-display">
                Jeff Dum&eacute;
              </span>
            </h1>

            <p
              className={`mt-5 sm:mt-8 text-white/60 text-sm md:text-base lg:text-lg max-w-xl leading-relaxed transition-all duration-700 delay-200 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              Helping Organizations Reduce Mis-Hires, Improve Retention, and Create More Consistent Hiring Decisions Through Human-Led AI.
            </p>

            <div
              className={`mt-3 sm:mt-5 transition-all duration-700 delay-250 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              <span className="text-white/40 text-xs md:text-sm font-medium tracking-wide">
                Speaker | Workforce Intelligence Advocate | Entrepreneur
              </span>
            </div>

            <div
              className={`mt-6 sm:mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4 transition-all duration-700 delay-300 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              <Link
                to="/speaking"
                className="inline-flex items-center justify-center gap-2 bg-gold text-charcoal font-semibold text-sm px-6 py-3.5 rounded-md hover:bg-gold-light transition-colors whitespace-nowrap"
              >
                Speaking &amp; Media
                <i className="ri-mic-line"></i>
              </Link>
              <a
                href="https://www.linkedin.com/in/jdume/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 border-2 border-white/30 text-white font-semibold text-sm px-6 py-3.5 rounded-md hover:border-gold hover:text-gold transition-colors whitespace-nowrap"
              >
                Connect on LinkedIn
                <i className="ri-linkedin-box-line"></i>
              </a>
            </div>
          </div>

          {/* Desktop image column */}
          <div className="hidden lg:flex lg:w-[38%] pt-4 justify-end">
            <div className="relative w-full max-w-[360px]">
              <div className="w-full aspect-[3/4] rounded-xl overflow-hidden border border-white/10 bg-dark-card">
                <img
                  src="/images/Jeff_D-28.jpg"
                  alt="Jeff Dumè, Founder of BuildFit AI and Mainframe Solutions, workforce intelligence advocate"
                  loading="eager"
                  fetchPriority="high"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 w-full h-full rounded-xl border border-gold/20 -z-10"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-charcoal via-charcoal/90 to-transparent z-0 pointer-events-none"></div>
    </header>
  );
}